/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_ConnectingInputs */

const en_ateliere_connect_status_connecting = /** @type {(inputs: Ateliere_Connect_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting to Ateliere Connect...`)
};

const fr_ateliere_connect_status_connecting = /** @type {(inputs: Ateliere_Connect_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion à Ateliere Connect...`)
};

const de_ateliere_connect_status_connecting = /** @type {(inputs: Ateliere_Connect_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung zu Ateliere Connect herstellen...`)
};

const it_ateliere_connect_status_connecting = /** @type {(inputs: Ateliere_Connect_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connessione ad Ateliere Connect...`)
};

const ru_ateliere_connect_status_connecting = /** @type {(inputs: Ateliere_Connect_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключение к Ateliere Connect...`)
};

const es_ateliere_connect_status_connecting = /** @type {(inputs: Ateliere_Connect_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectándose a Ateliere Connect...`)
};

const zh_cn2_ateliere_connect_status_connecting = /** @type {(inputs: Ateliere_Connect_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在连接到 Atelier Connect...`)
};

const ja_ateliere_connect_status_connecting = /** @type {(inputs: Ateliere_Connect_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ateliere Connectに接続しています...`)
};

const hi_ateliere_connect_status_connecting = /** @type {(inputs: Ateliere_Connect_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एटेलियर कनेक्ट से जुड़ रहे हैं...`)
};

const pt_pt2_ateliere_connect_status_connecting = /** @type {(inputs: Ateliere_Connect_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando-se ao Ateliere Connect...`)
};

/**
* | output |
* | --- |
* | "Connecting to Ateliere Connect..." |
*
* @param {Ateliere_Connect_Status_ConnectingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_connecting = /** @type {((inputs?: Ateliere_Connect_Status_ConnectingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_ConnectingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_connecting(inputs)
	if (locale === "de") return de_ateliere_connect_status_connecting(inputs)
	if (locale === "it") return it_ateliere_connect_status_connecting(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_connecting(inputs)
	if (locale === "es") return es_ateliere_connect_status_connecting(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_connecting(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_connecting(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_connecting(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_connecting(inputs)
	return en_ateliere_connect_status_connecting(inputs)
});